export default "__VITE_ASSET__CkedCNUL__"